import SaveIcon from '@mui/icons-material/Save';
import { Button,Stack,TextField } from "@mui/material";
import { useMutation,useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import AttToken from "../../helpers/attToken";
import { trackEventMatomo } from "../../helpers/matomo";
import Teams from "../../service/Teams";
import Users from "../../service/Users";
import { responseType } from "../../types/teams/types";
import GenericAutoComplete from "../GenericAutoComplete";

const usersService = new Users();

const equipeService = new Teams();

export default function TeamRegister() {
  const { t } = useTranslation('translation');
  const [usuarios, setUsuarios] = useState<string[]>([]);
  const [nome, setNome] = useState<string>("");

  function handleNome(event: React.ChangeEvent<HTMLInputElement>) {
    setNome(event.target.value);
  }

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['GET_USERS'],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const result: responseType = await usersService.getAllUsers({ ...token });
        return result.users;
      }
    },
    staleTime: 5 * 60 * 1000,
    retry: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
  });

  const { mutate, isPending } = useMutation({
    mutationKey: ['createTeam'],
    mutationFn: async () => {
      toast.info(t('teamManage.register.salvandoEquipe'));
      const token = await AttToken();
      if (token) {
        const response = await equipeService.createTeam(token, nome, usuarios, []);
        return response;
      }
    },
    onSuccess: () => {
      trackEventMatomo('cadastro de equipe', 'sucesso', 'salvamento', 'equipe cadastrada');
      toast.success(t('teamManage.register.toastSuccess'));
      setUsuarios([]);
      setNome("");
    },
    onError: () => {
      trackEventMatomo('cadastro de equipe', 'erro', 'salvamento', 'falha ao cadastrar equipe');
      toast.error(t('teamManage.register.erroSalvaEquipe'));
    }
  });

  const loading = isLoading || isFetching || isPending;

  return (
    <Stack
      width='100%'
      direction='column'
      justifyContent='flex-start'
      alignItems='flex-start'
      spacing={1.5}
      component='form'
      onSubmit={(e) => {
        e.preventDefault();
        mutate();
        trackEventMatomo('cadastro de equipe', 'click', 'button', 'salva');
      }}>
      <TextField
        disabled={loading}
        onClick={() => trackEventMatomo('detalhes de equipe', 'click', 'input', 'edita valor')}
        label={t('teamManage.register.teamName')}
        fullWidth
        slotProps={{ htmlInput: { maxLength: 80 } }}
        type="text"
        value={nome}
        onChange={handleNome}
      />
      <GenericAutoComplete
        label={t('Services.servicesManagement.members')}
        options={[...new Set(data)]?.map((user) => ({ value: user.id, label: user.nome })) ?? []}
        selectedValues={usuarios}
        onChange={setUsuarios}
        loading={loading}
      />
      <Button
        variant='contained'
        color='success'
        endIcon={<SaveIcon />}
        type="submit"
        disabled={(!nome.length || !usuarios.length) || loading}
      >
        {t('save')}
      </Button>
    </Stack>
  );
}
